import { Box, Drawer, IconButton, Stack } from "@mui/material";
import HeaderComponent from "../../components/panel/header/Header";
import UserAccountComponent from "../../components/panel/user-account-vicard/UserAccountViCard";
import { PanelContextProvider } from "../../context/panelContext";
import UserAccountMobileComponent from "../../components/panel/user-account-vicard/UserAccountMobileViCard";
import SidebarMenuComponent from "../../components/panel/sidebar-menu/SidebarMenu";
import SetPasswordComponent from "../../components/panel/set-password-modal/SetPassword";
import { Outlet } from "react-router-dom";
import AddNewWorkspaceModalComponent from "../../components/panel/set-workspace-modal/SetNewWorkSpace";
import { useState } from "react";
import { ProfileContextProvider } from "../../context/profileContext";
import { RoleAccessContextProvider } from "../../context/roleAccessContext";
import LoadingPage from "../../Loading";

export default function PanelLayout() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [accessSections, setAccessSections] = useState<string[]>([]);

  return (
    <ProfileContextProvider>
      <RoleAccessContextProvider
        accessSections={accessSections}
        setAccessSections={setAccessSections}
      >
        {accessSections.length > 0 ? (
          <PanelContextProvider
            drawerOpen={drawerOpen}
            setDrawerOpen={setDrawerOpen}
          >
            <Stack
              direction="column"
              justifyContent="start"
              alignItems="start"
              minHeight="fit-content"
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                width="100%"
              >
                <HeaderComponent />
              </Stack>

              <Stack width={"100%"} display={{ xs: "flex", md: "none" }}>
                <UserAccountMobileComponent />
              </Stack>
              <Stack
                direction="row"
                justifyContent="start"
                alignItems="start"
                sx={{
                  backgroundColor: ({ palette }) => palette.gray["bg"],
                }}
              >
                <Stack display={{ xs: "none", md: "flex" }}>
                  <Stack
                    position="fixed"
                    width="200px"
                    height="fit-content"
                    minHeight="100vh"
                    sx={{
                      backgroundColor: ({ palette }) => palette.gray[50],
                    }}
                  >
                    {/* Sidebar */}
                    <Stack display={{ xs: "none", md: "flex" }}>
                      {" "}
                      <UserAccountComponent />
                    </Stack>
                    <SidebarMenuComponent setDrawerOpen={setDrawerOpen} />
                  </Stack>
                  <Stack
                    width="200px"
                    height="100vh"
                    sx={{
                      backgroundColor: ({ palette }) => palette.gray[50],
                    }}
                  ></Stack>
                </Stack>
                <Drawer
                  sx={{
                    position: {
                      xs: "fixed",
                      md: "relative",
                    },
                  }}
                  PaperProps={{
                    sx: { width: "60%", maxWidth: "200px", minWidth: "200px" },
                  }}
                  open={drawerOpen}
                  onClose={() => setDrawerOpen(false)}
                  anchor="right"
                >
                  <Stack
                    position="relative"
                    height="100vh"
                    sx={{
                      backgroundColor: ({ palette }) => palette.gray[50],
                      width: { md: "calc(100vw - 200px)", xs: "200px" },
                    }}
                  >
                    <Box
                      sx={{
                        cursor: "pointer",
                        right: "21%",
                        top: "25px",
                        position: "absolute",
                      }}
                      onClick={() => setDrawerOpen(false)}
                    >
                      <IconButton>
                        <img src="/images/menu.svg" />
                      </IconButton>
                    </Box>
                    <SidebarMenuComponent setDrawerOpen={setDrawerOpen} />
                  </Stack>
                </Drawer>
                <Stack
                  sx={{
                    width: { xs: "100vw", md: "calc(100vw - 200px)" },
                    height: "fit-content",
                  }}
                >
                  <Stack
                    justifyContent="center"
                    alignItems="center"
                    minWidth="300px"
                    width="100%"
                  >
                    <Stack
                      sx={{
                        backgroundColor: ({ palette }) => palette.gray["bg"],
                      }}
                      color="black"
                      justifyContent="start"
                      alignItems="center"
                      width="100%"
                      height="fit-content"
                    >
                      <Outlet />
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
            <SetPasswordComponent />
            <AddNewWorkspaceModalComponent />
          </PanelContextProvider>
        ) : (
          <LoadingPage />
        )}
      </RoleAccessContextProvider>
    </ProfileContextProvider>
  );
}
